var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',[_vm._v("Belge Say.: "+_vm._s(_vm.BELGESAYISI))]),_c('vs-divider',{staticStyle:{"margin":"0px !important"}}),_vm._v("\n  Tutar: "+_vm._s(_vm.MALHIZMETBEDELI)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }